/**
 * axios을 이용하여 서버로 요청을 할 때마다, 페이지 최상단에 progress bar가
 * 진척도를 보여주기 위한 setup데이터
 */

import superFetch from './superFetch';
import SuperFetchV2 from './superFetchV2';

const requests = [];

let progress = 0;
let timerId = null;

function setProgress(value) {
  progress = value;
  if (typeof window !== 'undefined' && window.nanobar) {
    window.nanobar.go(progress);
  }
}

function timer() {
  if (progress < 98) {
    const diff = 100 - progress;
    const inc = diff / (10 + progress * (1 + progress / 100));
    setProgress(progress + inc);
  }
  timerId = setTimeout(timer, 50);
}

function setRequestInterceptors(axios) {
  axios.interceptors.request.use((req) => {
    if (requests.length === 0) {
      setProgress(25);
      timer();
    }
    requests.push(req);
    return req;
  });
}

export function nanoProgressSetup() {
  setRequestInterceptors(superFetch);
  setRequestInterceptors(SuperFetchV2);

  const responseHandler = (res) => {
    setTimeout(() => {
      requests.pop();
      if (requests.length === 0) {
        if (timerId) {
          clearTimeout(timerId);
          timerId = null;
        }
        setProgress(100);
      }
    }, 150);
    return res;
  };
  const errorHandler = (response) => {
    setTimeout(() => {
      requests.pop();
      if (requests.length === 0) {
        if (timerId) {
          clearTimeout(timerId);
          timerId = null;
        }
        setProgress(100);
      }
    }, 150);
    return Promise.reject(response);
  };
  superFetch.interceptors.response.use(responseHandler, errorHandler);
  SuperFetchV2.interceptors.response.use(responseHandler, errorHandler);
}
